<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
   
            :lang="{lengthMenu: 'Mostrar _MENU_ registros',
            zeroRecords: 'No se encontraron documentos con las características solicitadas',
            info: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
            infoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
            infoFiltered: '(filtrado de un total de _MAX_ registros)',
            filter:'Filtralo'}"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        :sorter="{Insumo: true}"
        :table-filter="{Insumo: true}"        
             :loading="loadCarga"
      
      >
        <template #Validación="{item}">
          <td>
            <CIcon :name="getValidation(item.Validación)" :hidden="item.Validación == null ? true : false"/>
          </td>
        </template>
        <template #txt_resultado="{item}">
          <td>
            <CButton
              v-c-tooltip="{
                content: item.txt_resultado,
                placement: 'right'
              }"
              :hidden="item.txt_resultado == null ? true : false"
            >
              Ver
            </CButton>
          </td>
        </template>
        <template #id_tipo_insumo_est="{item}">
          <td>
            <CButton
              color="secondary"
              :hidden="item.id_tipo_insumo_est == 3 ? true : false"
              v-text="getDocumentType(item.id_tipo_insumo_est)"
            ></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
      // return ['Insumo'	,'Fecha de Carga'	,'Cargar Insumo','Cantidad de Registros']}
    }},
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    lang: String
  },
  methods: {
    getValidation(item) {
      if (item) {
        return 'cil-check';
      }
      return 'cil-x-circle';
    },
    getDocumentType (item) {
      return item === 1 ? 'Excel'
        : item === 2 ? 'Texto'
          : 'Agregar valor'
    }
  },
   computed: {
     loadCarga(){         
      return this.items.length>=1?false:true
    } 
  }
}
</script>
